/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, target: NonNullable<unknown> }} Clubs_MineInputs */

const en_us2_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You: ${i?.value} of ${i?.target}`)
};

const pt_br2_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você: ${i?.value} de ${i?.target}`)
};

const es_419_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tú: ${i?.value} de ${i?.target}`)
};

const pt_pt2_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu: ${i?.value} de ${i?.target}`)
};

const fr_fr2_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toi : ${i?.value} sur ${i?.target}`)
};

const de_de2_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du: ${i?.value} von ${i?.target}`)
};

const it_it2_clubs_mine = /** @type {(inputs: Clubs_MineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu: ${i?.value} di ${i?.target}`)
};

/**
* | output |
* | --- |
* | "You: {value} of {target}" |
*
* @param {Clubs_MineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_mine = /** @type {((inputs: Clubs_MineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_MineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_mine(inputs)
	if (locale === "es-419") return es_419_clubs_mine(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_mine(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_mine(inputs)
	if (locale === "de-DE") return de_de2_clubs_mine(inputs)
	if (locale === "it-IT") return it_it2_clubs_mine(inputs)
	return en_us2_clubs_mine(inputs)
});
export { clubs_mine as "clubs.mine" }